<div className="wrapper">
  <div className="s-wrapper">
    <span id="company">
      {{ internshipData.company }}
    </span>
    <div id="role">
      Role: {{ internshipData.role }}
    </div>
    <div id="date">
      Duration: {{ internshipData.date }}
    </div>
    <div id="desc">
      <div v-for="s in internshipData.desc">
        {{ s }}
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
